import React, { useState, useEffect } from "react";
import Header from "../../../Components/clubDashboard/Header/Header";
import Header2 from "../../../Components/adminDashboard/Header/Header";
import getLocalData from "../../../shared/localStorage/getData";
import "../CatagoryManagment/AdminNew.scss";
import combinedServices from "../../../shared/services/user-service";
import Event1 from "../../../assets/images/event-img1.jpg";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from 'react-router-dom';

const AddEvents = () => {
  const [eventData, setEventData] = useState([]); // All events
  const [eventActiveData, setEventActiveData] = useState([]); // Active events
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [modalStep, setModalStep] = useState(1);
  const [productdata, setProductdata] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [page, setPage] = useState(1);
  const [limit] = useState(100);
  const [searchQueryNotAvailable, setSearchQueryNotAvailable] = useState(""); // For Not Available Events
  const [searchQueryAvailable, setSearchQueryAvailable] = useState(""); // For Available Events
  const location = useLocation();
  const navigate = useNavigate();
  const storeID = location.state?.storeID;
  const fromAdminStoreView = location.state?.adminstoreview;
  const isAdmin = getLocalData("admin_info", "isLogin");

    useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsResponse = await combinedServices.getProductsforUser({storeID:storeID});
        if (
          productsResponse &&
          productsResponse.data &&
          productsResponse.data.data
        ) {
          setProductdata(productsResponse.data.data || []);
          console.log("Products fetched successfully:", productsResponse.data.data);
        } else {
          console.error("No products found.");
        }
      } catch (error) {
        console.error("Error fetching Products:", error);
      }
    };
    fetchProducts();
  }, []);

  const staticProducts = [
    { id: 1, name: "Premium Coffee Beans", image: "https://via.placeholder.com/150x150/8B4513/FFFFFF?text=Coffee" },
    { id: 2, name: "Organic Tea Collection", image: "https://via.placeholder.com/150x150/228B22/FFFFFF?text=Tea" },
    { id: 3, name: "Artisan Pastries", image: "https://via.placeholder.com/150x150/DDA0DD/FFFFFF?text=Pastry" },
    { id: 4, name: "Fresh Sandwiches", image: "https://via.placeholder.com/150x150/FF6347/FFFFFF?text=Sandwich" },
    { id: 5, name: "Smoothie Blends", image: "https://via.placeholder.com/150x150/FF69B4/FFFFFF?text=Smoothie" },
    { id: 6, name: "Energy Drinks", image: "https://via.placeholder.com/150x150/00CED1/FFFFFF?text=Energy" }
  ];
  // Fetch all events
  const fetchEvents = async () => {
    try {
      const response = await combinedServices.GetAllEvents({storeID:storeID});
      setEventData(response.data.events);
    } catch (error) {
      console.error("Error fetching all events:", error);
    }
  };

  // Fetch active store events
  const fetchActiveStoreEvents = async () => {
    try {
      const response = await combinedServices.GetAllActivestoreEvents({storeID:storeID});
      console.log(response);
      
      setEventActiveData(response.data);
    } catch (error) {
      console.error("Error fetching active store events:", error);
    }
  };

  // Fetch events on component mount
  useEffect(() => {
    fetchEvents();
    fetchActiveStoreEvents();
  }, [page]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
    setModalStep(1);
    setSelectedProducts([]);
  };

  const handleProductSelect = (productId) => {
    console.log('Selected Product ID:', productId);
    setSelectedProducts(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };

  const handleModalNext = () => {
    eventstatusUpdate(selectedEvent.id, selectedProducts);
    setShowModal(false);
    setModalStep(1);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedEvent(null);
    setModalStep(1);
    setSelectedProducts([]);
  };

  // Function to update event status
  const eventstatusUpdate = async (id, productIds = []) => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to update the event status?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true
      });

      if (!confirmResult.isConfirmed) return;

      const requestBody = { 
        id, 
        storeID, 
        productIds: JSON.stringify(productIds)
      };
      console.log(requestBody);
      const response = await combinedServices.UpdateEventstatusforstore(requestBody);

      if (response) {
        Swal.fire({
          title: "Success!",
          text: `Event status updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          if (fromAdminStoreView) {
            navigate(`/admin-store-view/${storeID}?tab=productList`);
          } else {
            navigate(`/adminstorelist?storeId=${storeID}&tab=productList`);
          }
        });
      } else {
        throw new Error("Status update failed.");
      }
    } catch (error) {
      console.error("Error updating event status:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to update event status. Please try again.",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  };

  // Filtering events based on search queries
  const filteredNotAvailableEvents = (eventData || []).filter((event) =>
    event.full_title.toLowerCase().includes(searchQueryNotAvailable.toLowerCase())
  );

  const filteredAvailableEvents = (eventActiveData || []).filter((event) =>
    event.full_title.toLowerCase().includes(searchQueryAvailable.toLowerCase())
  );

  return (
    <>
      {isAdmin ? <Header2 /> : <Header />}
      <div
        className="dbAdminRight newDbRight"
        style={{ padding: `0 0 0 ${isAdmin ? "200px" : "140px"}` }}
      >
        <div className="dbMid dbInner">
          <div className="dbMainHd">Add Events</div>
          <div className="whtBoxWrpOuter">
            <form>
              <div
                className="whtBoxWrpper"
                style={{ display: "flex", gap: "20px" }}
              >
                <div
                  className="wbx_Cont wbx_left"
                  style={{ flex: 1, maxHeight: "650px", overflowY: "auto" }}
                >
                  <h1 style={{ textAlign: "center" }}>
                    Not Available in store Events
                  </h1>
                  <br />
                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQueryNotAvailable}
                      onChange={(e) =>
                        setSearchQueryNotAvailable(e.target.value)
                      }
                      className="form_ctrl ctrlSrch"
                      placeholder="Search Not Available Events"
                    />
                  </div>
                  <br />
                  <ul className="d-flex flex-wrap p-0 productList">
                    {filteredNotAvailableEvents.map((event, index) => (
                      <li
                        className="col-12 col-md-3 mb-3"
                        key={index}
                        onClick={() => handleEventClick(event)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="inner">
                          <div className="img">
                            <img
                              src={
                                event.image?.startsWith("https://nambaweb.s3")
                                  ? event.image
                                  : Event1
                              }
                              alt={event.full_title || `Event ${index + 1}`}
                            />
                          </div>
                          <div className="name mt-3 text-center">
                            <div className="event-title">
                              {event.full_title || "Event Title"}
                            </div>
                            <span
                              className="d-block pt-1 event-price"
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                              }}
                            >
                              $
                              {parseFloat(
                                event.registration_charge || "0.00"
                              ).toFixed(2)}{" "}
                              USD
                            </span>
                            <span
                              className="d-block event-date"
                              style={{ fontSize: "12px", color: "#999" }}
                            >
                              {new Date(
                                event.registration_open
                              ).toLocaleDateString()}{" "}
                              -{" "}
                              {new Date(
                                event.registration_close
                              ).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="wbx_Cont wbx_right"
                  style={{ flex: 1, maxHeight: "650px", overflowY: "auto" }}
                >
                  <h1 style={{ textAlign: "center" }}>
                    Available in store Events
                  </h1>
                  <br />
                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQueryAvailable}
                      onChange={(e) => setSearchQueryAvailable(e.target.value)}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search Available Events"
                    />
                  </div>
                  <br />
                  <ul className="d-flex flex-wrap p-0 productList">
                    {filteredAvailableEvents.map((event, index) => (
                      <li
                        className="col-12 col-md-3 mb-3"
                        key={index}
                        onClick={() => eventstatusUpdate(event.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="inner">
                          <div className="img">
                            <img
                              src={
                                event.image?.startsWith("https://nambaweb.s3")
                                  ? event.image
                                  : Event1
                              }
                              alt={event.full_title || `Event ${index + 1}`}
                            />
                          </div>
                          <div className="name mt-3 text-center">
                            <div className="event-title">
                              {event.full_title || "Event Title"}
                            </div>
                            <span
                              className="d-block pt-1 event-price"
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                              }}
                            >
                              $
                              {parseFloat(
                                event.registration_charge || "0.00"
                              ).toFixed(2)}{" "}
                              USD
                            </span>
                            <span
                              className="d-block event-date"
                              style={{ fontSize: "12px", color: "#999" }}
                            >
                              {new Date(
                                event.registration_open
                              ).toLocaleDateString()}{" "}
                              -{" "}
                              {new Date(
                                event.registration_close
                              ).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "30px",
              width: "90%",
              maxWidth: "1200px",
              maxHeight: "90vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <button
              onClick={handleModalClose}
              style={{
                position: "absolute",
                top: "15px",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              ×
            </button>

            <div>
              <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Select Free Products for Event (Optional)</h2>
              <h3 style={{ textAlign: 'center', marginBottom: '20px', color: '#666' }}>
                {selectedEvent?.full_title}
              </h3>
              <div
                className="products-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "20px",
                  marginBottom: "30px",
                }}
              >
                {productdata.map((product, index) => {
                  const isSelected = selectedProducts.includes(
                    product.product_id
                  );
                  return (
                    <div
                      key={`product-${product.product_id}-${index}`}
                      style={{
                        border: isSelected
                          ? "2px solid #007bff"
                          : "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "15px",
                        textAlign: "center",
                        cursor: "pointer",
                        transition: "all 0.2s",
                        backgroundColor: isSelected ? "#f0f8ff" : "white",
                        position: "relative",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleProductSelect(product.product_id)}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                      />
                      <div
                        onClick={() => handleProductSelect(product.product_id)}
                      >
                        <img
                          src={JSON.parse(product.images)[0]}
                          alt={product.product_name}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            marginBottom: "10px",
                          }}
                        />
                        <h4 style={{ margin: "10px 0", fontSize: "16px" }}>
                          {product.product_name}
                        </h4>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ textAlign: "center" }}>
                <p style={{ marginBottom: "20px", color: "#666" }}>
                  Selected Products: {selectedProducts.length}
                </p>
                <button
                  onClick={handleModalNext}
                  style={{
                    backgroundColor:'#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '12px 30px',
                    borderRadius: '5px',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                >
                  Next ({selectedProducts.length} selected)
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddEvents;